import {Component, ViewEncapsulation} from "@angular/core";

@Component({
    selector     : '.radio-demo',
    encapsulation: ViewEncapsulation.None,
    template: `<h4>Radio Buttons</h4>
<h5>Example</h5>
<div class="card card-body bg-light form-group">
    <form #testForm="ngForm" novalidate>
        <check-box [(ngModel)]="model.required"
                   name="required"
                   label="Is Required"
                   labelPlacement="after"></check-box>
        <check-box [(ngModel)]="model.horizontal"
                   name="horizontal"
                   label="Is Horizontal"
                   labelPlacement="after"></check-box>
        <radio-group [name]="model.name"
                     label="Test Radio Group"
                     [direction]="model.horizontal ? 'horizontal' : 'vertical'"
                     [options]="model.options"
                     [required]="model.required"
                     [(ngModel)]="model.value">
        </radio-group>
        <submit-button label="Submit" [formGroup]="testForm.form"></submit-button>
    </form>
</div>
<h5>Data Model</h5>
<pre class="card card-body bg-light">{{ model | json }}</pre>
<h5>Markup</h5>
<pre class="card card-body bg-light">{{ markup }}</pre>
`
})
export class RadioDemoComponent {

    model = {
        name    : 'testRadio',
        required: false,
        horizontal: false,
        value   : '',
        options : [
            {
                label: 'Option 1',
                value: 'option-1'
            },
            {
                label: 'Option 2',
                value: 'option-2'
            },
            {
                label: 'Option 3',
                value: 'option-3'
            }
        ]
    };

    markup = `
<radio-group [name]="model.name"
             label="Test Radio Group"
             [options]="model.options"
             [required]="model.required"
             [(ngModel)]="model.value">
</radio-group>
    `;
}


